import { Reveal } from "./Reveal";

const SectionHeading = ({ eyebrow, title, description, align = "center", dark = false }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : "text-left"}`}>
    <span className="inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-gold" data-testid="section-eyebrow">
      <span className="h-px w-8 bg-gold" />
      {eyebrow}
      {align === "center" && <span className="h-px w-8 bg-gold" />}
    </span>
    <h2 className={`mt-5 font-display text-4xl leading-[1.08] sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-navy"}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-6 text-base leading-relaxed md:text-lg ${dark ? "text-white/60" : "text-navy/60"}`}>
        {description}
      </p>
    )}
  </Reveal>
);

export default SectionHeading;
